

export class ShowHideLogicMetadataBase {

    ref: string | null = null
    value: string | boolean | null = null

    constructor() {}

    static hasValue(data: ShowHideLogicMetadataBase): boolean {
        if (data == null) return false
        return data.ref != null && data.value != null
    }

    static hasAnyValue(data: ShowHideLogicMetadataBase []): boolean {
        if (data == null || data.length == 0) return false

        for (let element of data) {
            if (element.ref != null && element.value != null) return true
        }

        return false
    }

}

export interface ShowHideLogicMetadata extends ShowHideLogicMetadataBase { }